import { useState, useEffect, useCallback, useRef } from 'react'
import { hash } from '../utils/hashFunction'
import { axiosInstanceContratos } from '../utils/axiosGlobalUtils'
import { ContractDTO } from '../dto/ContractDTO'
import { getPerfilImp } from '../pages/Contracts/Vencimientos/contracts.services'

export const useLocalContracts = (idLocal: string | undefined) => {
  const [contracts, setContracts] = useState<ContractDTO[]>([])
  const [forzarRenovables, setForzarRenovables] = useState<boolean>(false)
  const [perfil, setPerfil] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const perfilFetched = useRef(false)

  const consultarPerfil = useCallback(async () => {
    try {
      const res = await getPerfilImp(idLocal)
      setPerfil(res.data)
    } catch (e) {
      console.log(e)
    }
  }, [idLocal])

  const fetchLocalContracts = useCallback(
    async (idLocal: any, forzarRenovables: boolean) => {
      setLoading(true)
      const clave = await hash(idLocal.toString() + 'lugares2017')
      const url = forzarRenovables
        ? `/contratos/local/${idLocal}?clave=${clave}&forzar-renovable=true`
        : `/contratos/local/${idLocal}?clave=${clave}`
      axiosInstanceContratos
        .get(url)
        .then(async (result) => {
          const data = result.data
          data.sort((a: any, b: any) => a.fechaFinFormateada - b.fechaFinFormateada)
          setContracts(data)

          if (data.length > 0 && !perfilFetched.current) {
            perfilFetched.current = true
            await consultarPerfil()
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => setLoading(false))
    },
    [consultarPerfil]
  )

  useEffect(() => {
    perfilFetched.current = false
    setPerfil(null)
  }, [idLocal])

  useEffect(() => {
    if (idLocal && idLocal !== '0') {
      fetchLocalContracts(idLocal, forzarRenovables)
    }
  }, [idLocal, forzarRenovables])

  return {
    contracts,
    forzarRenovables,
    perfil,
    loading,
    setForzarRenovables,
    fetchLocalContracts,
    consultarPerfil
  }
}
